import axios from "axios";
import API_URL from "../config/config";
export const getCourses = async ({ user_id, assessment_id }) => {
  console.log(user_id, assessment_id);
  const url = assessment_id
    ? `${API_URL}/dashboard/getAllCoursesByUserAssessment/${user_id}/${assessment_id}`
    : `${API_URL}/dashboard/getAllCoursesByUser/${user_id}`;
  try {
    return axios.get(url);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
